var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Avatar, When } from "@alife/simple-ui";
import Icon from "@alife/next-icon";
import TypeMessageCard, { CardTypeCode, CardTypeName } from "../cards";
import ReadType from "../../types/read-type";
import classnames from "classnames";
import Balloon from "@alife/next/lib/balloon";
var statusRenderMap = {};
statusRenderMap[ReadType.unread] = "Unread";
statusRenderMap[ReadType.read] = "Read";
statusRenderMap[ReadType.loading] = (React.createElement(Icon, { className: "read-type", type: "loading" }));
statusRenderMap[ReadType.loading2] = (React.createElement(Icon, { className: "read-type", type: "loading" }));
statusRenderMap[ReadType.warning] = (React.createElement(Icon, { className: "read-type", type: "prompt", style: { color: "red" } }));
var MessageItem = (function (_super) {
    __extends(MessageItem, _super);
    function MessageItem(props) {
        var _a, _b;
        var _this = _super.call(this, props) || this;
        _this.currentTime = new Date().getTime();
        _this.handleMouse = function (boolean) {
            _this.setState({
                messageWithdrawActive: boolean,
            });
        };
        var _c = props.locale, locale = _c === void 0 ? {} : _c;
        _this.state = {
            messageWithdrawActive: true,
            buyerMessageRate: (_b = (_a = props === null || props === void 0 ? void 0 : props.message) === null || _a === void 0 ? void 0 : _a.ext) === null || _b === void 0 ? void 0 : _b.buyerMessageRate,
        };
        statusRenderMap[ReadType.unread] = (React.createElement("span", { className: "read-type unread-type" }, locale.unread || "Unread"));
        statusRenderMap[ReadType.read] = (React.createElement("span", { className: "read-type" }, locale.read || "Read"));
        return _this;
    }
    MessageItem.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var thisMessage = this.props.message;
        var nextMessage = nextProps.message;
        return (thisMessage.messageId !== nextMessage.messageId ||
            (thisMessage.ext === undefined && !!nextMessage.ext) ||
            thisMessage.status !== nextMessage.status ||
            thisMessage.readStatus !== nextMessage.readStatus ||
            thisMessage.displayAvatar !== nextMessage.displayAvatar ||
            this.state.messageWithdrawActive !== nextState.messageWithdrawActive);
    };
    MessageItem.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, message = _b.message, langKey = _b.langKey, locale = _b.locale, onDelete = _b.onDelete, onResend = _b.onResend, messageWithdraw = _b.messageWithdraw, reUpdateInputMessage = _b.reUpdateInputMessage, doLikeSendRequest = _b.doLikeSendRequest, avatarFallback = _b.avatarFallback, restProps = __rest(_b, ["message", "langKey", "locale", "onDelete", "onResend", "messageWithdraw", "reUpdateInputMessage", "doLikeSendRequest", "avatarFallback"]);
        if (message.readType === ReadType.warning) {
            statusRenderMap[ReadType.warning] = (React.createElement(Icon, { className: "read-type clickable", onClick: function () { return onDelete(message.messageId || ""); }, type: "prompt", style: { color: "red" } }));
        }
        var user = message.user, cardType = message.cardType, messageId = message.messageId, sendTime = message.sendTime, ext = message.ext;
        var _c = (ext || {}).ai_msg, ai_msg = _c === void 0 ? "" : _c;
        var userType = user.userType, headUrl = user.headUrl, userId = user.userId;
        var AIHeaderUrl = "https://img.mrvcdn.com/us/media/6ce364b290e4fc28d19676141d826580-109-109.jpg";
        var headPic = ai_msg === "true" ? AIHeaderUrl : headUrl;
        var isSystemMessage = CardTypeCode.CardSystem === message.cardType;
        var fallbackSrc = (userType && (avatarFallback === null || avatarFallback === void 0 ? void 0 : avatarFallback[userType])) || undefined;
        var onSwitchLike = function (_a) {
            var rateType = _a.rateType;
            doLikeSendRequest &&
                doLikeSendRequest({ rateType: rateType, sellerUserId: userId, messageId: messageId, remark: '' }, function () {
                    _this.setState({
                        buyerMessageRate: rateType,
                    });
                });
        };
        var buyerMessageRate = this.state.buyerMessageRate;
        var ratedColor = "#6966E8";
        var notRatedColor = "#8F94A4";
        var likeColor = buyerMessageRate === "1" ? ratedColor : notRatedColor;
        var dislikeColor = buyerMessageRate === "2" ? ratedColor : notRatedColor;
        var likeIcon = (React.createElement("svg", { className: "like-icon " + (buyerMessageRate ? "noDrap" : ""), onClick: function () {
                if (!buyerMessageRate) {
                    onSwitchLike({ rateType: "1" });
                }
            }, xmlns: "http://www.w3.org/2000/svg", width: "19", height: "19", viewBox: "0 0 19 19", fill: "none" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.3969 1.84961H12.5676L11.9676 7.09961H17.1572V12.39L14.438 16.8496H8.65723H7.40723H2.15723V9.34961H3.15723V15.8496H4.65723V7.84961H2.15723V6.84961H5.8969L9.3969 1.84961ZM5.65723 7.84961V15.8496H7.40723H8.65723H13.8765L16.1572 12.1092V8.09961H10.8468L11.4468 2.84961H9.91755L6.41755 7.84961H5.65723Z", fill: likeColor })));
        var dislikeIcon = (React.createElement("svg", { className: "dislike-icon " + (buyerMessageRate ? "noDrap" : ""), onClick: function () {
                if (!buyerMessageRate) {
                    onSwitchLike({ rateType: "2" });
                }
            }, xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.3969 15.8496H10.5676L9.96762 10.5996H15.1572V5.30919L12.438 0.849609H6.65723H5.40723H0.157227V8.34961H1.15723V1.84961H2.65723V9.84961H0.157227V10.8496H3.8969L7.3969 15.8496ZM3.65723 9.84961V1.84961H5.40723H6.65723H11.8765L14.1572 5.59003V9.59961H8.84683L9.44683 14.8496H7.91755L4.41755 9.84961H3.65723Z", fill: dislikeColor })));
        return (React.createElement("div", { className: "message-row user-type-" + userType + " row-" + CardTypeName[message.cardType], onMouseEnter: function () { return _this.handleMouse(false); }, onMouseLeave: function () { return _this.handleMouse(true); } },
            React.createElement(When, { condition: !isSystemMessage && !!message.displayAvatar },
                React.createElement(Avatar, { src: headPic, shape: "circle", fallbackSrc: fallbackSrc })),
            React.createElement(When, { condition: !message.displayAvatar || isSystemMessage },
                React.createElement("div", { className: "avatar-holder" })),
            React.createElement("div", { className: "message-contain" },
                this.currentTime - sendTime < 1000 * 60 * 2 &&
                    (cardType === 1 ||
                        cardType === 3 ||
                        cardType === 4 ||
                        cardType === 5 ||
                        cardType === 10003 ||
                        cardType === 10004) &&
                    !message.processResult && (React.createElement("div", { className: classnames({
                        "message-withdraw-active": this.state.messageWithdrawActive,
                    }) },
                    React.createElement(Balloon.Tooltip, { align: "t", text: locale.recall || "Recall", className: "withdrawBalloon", trigger: React.createElement("div", { className: "message-withdraw", onClick: function () { return messageWithdraw(messageId || ""); } },
                            React.createElement("span", null,
                                React.createElement("svg", { viewBox: "0 0 1024 1024", version: "1.1", width: "10", height: "10" },
                                    React.createElement("path", { d: "M321.836 517.083c11.36 11.617 11.339 30.135 0.088 41.727l-0.553 0.555c-11.613 11.364-30.124 11.342-41.711 0.087l-0.555-0.553L71.523 346.61c-11.209-11.461-11.358-29.681-0.471-41.323l0.544-0.567L279.178 93.917c11.585-11.764 30.508-11.906 42.268-0.318 11.573 11.405 11.894 29.921 0.86 41.719l-0.543 0.565-157.477 159.918h517.718c148.563 0 268.996 120.48 268.996 269.1 0 147.133-118.037 266.687-264.547 269.063l-4.449 0.036H235.952c-16.507 0-29.889-13.387-29.889-29.9 0-16.277 13.002-29.517 29.183-29.892l0.706-0.008h446.052c115.549 0 209.22-93.706 209.22-209.3 0-114.436-91.807-207.422-205.76-209.27l-3.46-0.028-518.069-0.001 157.901 161.482z", fill: "#666666", "p-id": "1734" })))) }))),
                React.createElement(TypeMessageCard, __assign({}, message, restProps, { langKey: langKey, locale: locale, onDelete: onDelete, onResend: onResend, reUpdateInputMessage: reUpdateInputMessage })),
                React.createElement(When, { condition: !isSystemMessage && !message.hideState && !message.processResult },
                    React.createElement("div", { className: "message-read-type" }, statusRenderMap[message.readType])),
                React.createElement(When, { condition: !!message.processResult },
                    React.createElement("div", { className: "message-process-result" }, (_a = message.processResult) === null || _a === void 0 ? void 0 : _a.content)),
                React.createElement(When, { condition: ai_msg === "true" },
                    React.createElement("div", { className: "message-icon-box" },
                        dislikeIcon,
                        likeIcon))),
            React.createElement("div", { className: "avatar-holder" })));
    };
    return MessageItem;
}(React.Component));
export default MessageItem;

//# sourceMappingURL=index.js.map
